"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconUiTumblr = function IconUiTumblr(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react.default.createElement("svg", _extends({
    className: (0, _classnames.default)(className, 'svg-icon'),
    viewBox: "0 0 48 48"
  }, props), _react.default.createElement("path", {
    d: "M29.456 45.1a18.862 18.862 0 0 0 6.094-.983 7.832 7.832 0 0 0 3.882-2.408l.295-.393-2.654-7.916a.192.192 0 0 0-.2-.147H30.93a.2.2 0 0 1-.2-.1 6.125 6.125 0 0 1-.1-.983v-9.727c0-.131.049-.2.148-.2h7.082c.1 0 .147-.066.147-.2v-9.921a.13.13 0 0 0-.147-.147h-7.028a.174.174 0 0 1-.2-.2V2.1a.174.174 0 0 0-.2-.2h-12.28a1.96 1.96 0 0 0-1.278.491 2.406 2.406 0 0 0-.737 1.426 12.1 12.1 0 0 1-2.212 6.045A10.288 10.288 0 0 1 8.912 13.2l-.442.2a.13.13 0 0 0-.147.148v8.5a.174.174 0 0 0 .2.2h4.374v10.516Q12.893 45.1 29.456 45.1zM15.007 14.826a.2.2 0 0 1 .1-.2q6.734-2.606 7.667-10.616a.633.633 0 0 1 .147-.295l.148-.049h5.652c.1 0 .147.066.147.2v9.682a.174.174 0 0 0 .2.2h7.028a.131.131 0 0 1 .147.148v6.434a.13.13 0 0 1-.147.147h-7.083c-.1 0-.147.066-.147.2v11.5q.05 3.883 3.686 3.883a9.18 9.18 0 0 0 3.145-.59c.131-.065.213-.033.246.1l1.769 5.308a.1.1 0 0 1-.049.148 7.784 7.784 0 0 1-2.9 1.671 11.764 11.764 0 0 1-3.834.639h-.295q-5.849 0-8.846-3.785a10.711 10.711 0 0 1-2.261-6.782V20.674c0-.131-.049-.2-.147-.2h-4.226a.13.13 0 0 1-.147-.147z"
  }));
};

IconUiTumblr.propTypes = {
  className: _propTypes.default.string
};
var _default = IconUiTumblr;
exports.default = _default;